import { render, staticRenderFns } from "./WhoHasAccess.vue?vue&type=template&id=d1cb1e48&scoped=true&"
import script from "./WhoHasAccess.vue?vue&type=script&lang=ts&"
export * from "./WhoHasAccess.vue?vue&type=script&lang=ts&"
import style0 from "./WhoHasAccess.vue?vue&type=style&index=0&id=d1cb1e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cb1e48",
  null
  
)

export default component.exports